import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { UserSessionService, activeSessionErrors } from './user-session.service';
import { EventManagerService } from './event-manager.service';

@Injectable({ providedIn: 'root' })
export class AuthGuardService implements CanActivate {
  controlVar: any;
  constructor(
    private _userSession: UserSessionService,
    private _eventManager: EventManagerService,
  ) { }

  async canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const requestedRoute = state.url;
    const errorCode = await this._userSession.activeSession();
    if (errorCode === activeSessionErrors.validSession) {
      if (!this._userSession.userCanNavigate(requestedRoute)) {
        this._eventManager.next('notAuthorized', null);
        return false;
      }
      return true;
    }
    if (errorCode === activeSessionErrors.expiredOnServer) {
      this._eventManager.next('sessionEnded', requestedRoute);
    } else if (errorCode === activeSessionErrors.concurrentSession) {
      this._eventManager.next('sessionEnded', null);
    } else if (errorCode === activeSessionErrors.noSession) {
      this._eventManager.next('noSessionNext', requestedRoute);
      this._eventManager.next('startApp', {});
    } else {
      this._eventManager.next('startApp', {});
    }
    return false;
  }
}
